import React from 'react';
import TagIcon from '@heroicons/react/outline/CursorClickIcon.js';
import { BlockType } from '../../types/index.js';
import { HighlightedTags as Component } from './Block.js';
import { HighlightedTagsBlockSettings as Settings } from './Settings.js';
export const RegisteredHighlightedTagsBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'HighlightedTags',
        Component,
        config: {
            type: BlockType.Block,
            deprecated: true,
            displayName: $t({
                id: 'Blocks.HighlightedTags.displayName',
                defaultMessage: 'Highlighted {TAGS_CC}',
            }),
            Settings,
            Icon: React.createElement(TagIcon, null),
            defaultProps: {
                title: $t({
                    id: 'Blocks.HighlightedTags.displayName',
                    defaultMessage: 'Highlighted {TAGS_CC}',
                }),
            },
        },
    };
};
//# sourceMappingURL=registered.js.map